import { loader } from 'graphql.macro';
import { useMutation, useApolloClient } from '@apollo/client';
import { useOnlineStatus } from './offline-misc';
import { useCachedMutations } from './offline-misc';
import { useWorkspace } from '../../providers/WorkspaceProvider';
import { v4 as uuidv4 } from 'uuid';

const updateVehicleMutation = loader(
  '../../components/inspections/inspection_items/InspectionItemAsset.update.graphql',
);
const vehicleFragment = loader(
  '../../pages/fleet/Vehicle.vehicleFragment.graphql',
);

export const useUpdateVehicle = () => {
  const [updateVehicle] = useMutation(updateVehicleMutation);
  const client = useApolloClient();
  const online = useOnlineStatus();
  const { addMutation } = useCachedMutations();
  const { workspaceVehicles } = useWorkspace();

  const updateAsset = async ({ id, odometer, hours, status }) => {
    const options = {
      variables: { id, odometer, hours, status },
    };

    // Prefer cache; fall back to workspaceVehicles
    const cacheId = client.cache.identify({ __typename: 'Vehicle', id });
    const cachedVehicle = client.readFragment({
      id: cacheId,
      fragment: vehicleFragment, // must include id, odometer, hours, status
    });
    const vehicle = cachedVehicle ||
      workspaceVehicles?.find((v) => String(v.id) === String(id)) || {
        __typename: 'Vehicle',
        id,
      };

    if (online) {
      return updateVehicle(options);
    } else {
      const updatedVehicle = {
        __typename: 'Vehicle',
        ...vehicle,
        id,
        odometer: odometer ?? vehicle?.odometer ?? null,
        hours: hours ?? vehicle?.hours ?? null,
        status: status ?? vehicle?.status ?? null,
      };

      // Write to cache using your fragment; if it’s missing fields, fall back to a minimal patch
      try {
        client.writeFragment({
          id: cacheId,
          fragment: vehicleFragment,
          data: updatedVehicle,
        });
      } catch (e) {
        console.error(e);
      }

      const uuid = uuidv4().toString();

      await addMutation(
        updateVehicleMutation,
        options,
        uuid,
        updatedVehicle,
        [],
        '',
        false,
      );

      return Promise.resolve({
        data: { updateVehicle: updatedVehicle },
      });
    }
  };
  return updateAsset;
};
